import { t, translate } from "../../I18n";
import { observer } from "mobx-react";
import { h } from "preact";
import ItemCountBadge from "./ItemCountBadge";
function SectionItemButton(props) {
    const { menuSectionItemContent, openProductCreator } = props;
    const handleClick = (variant) => {
        openProductCreator(variant.creator());
    };
    switch (menuSectionItemContent.type) {
        case "SingleProduct": {
            const { dropdown } = menuSectionItemContent;
            if (dropdown === null) {
                return null;
            }
            switch (dropdown.type) {
                case "SingleDropdown":
                    return (h(SingleVariantButton, { dropdown: dropdown, onClick: () => handleClick(dropdown.item) }));
                case "VariantsDropdown":
                    return (h(MultiplePVariantsDropdown, { dropdown: dropdown, onClick: handleClick }));
            }
        }
        case "Creator":
            return (h(CreatorButton, { onClick: () => handleClick(menuSectionItemContent.variant) }));
        default:
            return null;
    }
}
const CreatorButton = observer((props) => {
    const { onClick } = props;
    return (h("button", { onClick: onClick, type: "button", class: "btn add-button" },
        h("span", { class: "icon-btn icon-shopping-cart", "aria-label": translate(t.theme_defaults.menu.add_to_cart) })));
});
const MultiplePVariantsDropdown = observer((props) => {
    const { dropdown, onClick } = props;
    const handleClick = (event, variant) => {
        event.preventDefault();
        if (variant.isAvailable) {
            onClick(variant);
        }
    };
    return (h("div", { class: "btn-group" },
        h("button", { type: "button", class: "btn add-button dropdown-toggle", "data-bs-toggle": "dropdown", "data-bs-display": "static", "aria-expanded": "false", disabled: !dropdown.isAvailable },
            h("i", { class: "icon-btn icon-shopping-cart u-mr1", "aria-hidden": "true" }),
            " ",
            getPriceText(dropdown.price),
            " ",
            h("span", { class: "caret" })),
        h("ul", { class: "dropdown-menu" }, dropdown.items.map((item) => (h("li", { class: !item.isAvailable ? "disabled" : "" },
            h("a", { href: "#", onClick: (event) => handleClick(event, item) },
                h(VariantTextWithBadge, { item: item, showChoiceName: true }))))))));
});
const SingleVariantButton = observer((props) => {
    const { dropdown, onClick } = props;
    const { item } = dropdown;
    const isDisabled = !item.isAvailable;
    return (h("button", { onClick: onClick, type: "button", class: "btn add-button", disabled: isDisabled },
        h("i", { class: "icon-btn icon-shopping-cart u-mr1", "aria-hidden": "true" }),
        " ",
        h(VariantTextWithBadge, { item: item, showChoiceName: false })));
});
const VariantTextWithBadge = observer(({ item, showChoiceName, }) => {
    return (h("span", null,
        getVariantText(item, showChoiceName),
        " ",
        h(ItemCountBadge, { count: item.inCartQuantity })));
});
function getVariantText(variant, showChoiceName) {
    const { price, variantParameterChoiceName } = variant;
    let label = [];
    if (showChoiceName && variantParameterChoiceName.length > 0) {
        label.push(variantParameterChoiceName);
    }
    const priceText = getPriceText(price);
    if (priceText !== null && priceText.length > 0) {
        label.push(priceText);
    }
    return label.join(" – ");
}
function getPriceText(price) {
    switch (price.type) {
        case "null":
            return translate(t.theme_defaults.menu.add_to_cart);
        case "value":
            return price.priceValue;
        case "range":
            return `${translate(t.theme_defaults.menu.price_from)} ${price.minPriceValue}`;
    }
}
export default observer(SectionItemButton);
